import { createContext } from 'react';
import type { Notification } from '@/api/notifications';

/** The poll cadence - 60s, per the spec's "reasonable interval". */
export const POLL_INTERVAL_MS = 60_000;

/** Load state the consumers may switch on. `'error'` keeps the last list intact (fail-soft). */
export type NotificationsStatus = 'loading' | 'ready' | 'error';

export interface NotificationsContextValue {
  /** The actionable notification set (OPEN + ACKNOWLEDGED) from the last successful load. */
  notifications: Notification[];
  /**
   * The attention count the bell badges (hidden at 0): the server's actionable
   * `totalElements`, falling back to the loaded list length when the server sent
   * no total (DNKADM-0243 — the page is bounded, so row-counting undercounts).
   */
  openCount: number;
  /** Count of OPEN rows with `severity === 'ERROR'` - drives the badge emphasis color. */
  openErrorCount: number;
  /** The fail-soft load state. */
  status: NotificationsStatus;
  /** Force an immediate refresh (e.g. after an acknowledge in U2). */
  refresh: () => void;
}

export const NotificationsContext = createContext<NotificationsContextValue | null>(null);
